const TopicSubtopics = {
	init() {
		const container = document.querySelector('[data-component="topic-subtopics"]');
		if (!container) return;

		this.initSubtopicsSearch(container);
	},

	initSubtopicsSearch(container) {
		const searchInput = container.querySelector('[data-subtopics-search]');
		const grid = container.querySelector('[data-subtopics-grid]');
		const empty = container.querySelector('[data-subtopics-empty]');

		if (!searchInput || !grid) return;

		const pills = Array.from(grid.querySelectorAll('.topic-subtopics__pill'));

		let debounceTimer = null;

		searchInput.addEventListener('input', () => {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => {
				const query = searchInput.value.trim().toLowerCase();
				let visibleCount = 0;

				pills.forEach((pill) => {
					const name = pill.dataset.subtopicName || '';
					const matches = !query || name.includes(query);
					pill.classList.toggle('is-hidden', !matches);
					if (matches) visibleCount++;
				});

				if (empty) {
					empty.hidden = visibleCount > 0;
				}
			}, 200);
		});
	},
};

export default TopicSubtopics;
